import { Box, styled } from '@mui/material';
import Search from '@ui/Search';
import Typography from '@ui/Typography';
import { authorizedServerFetch } from 'actions/server.actions';
import { isEmpty } from 'lodash-es';
import React, { useEffect } from 'react';
import NonProfitItem from './NpoItem';

const CardContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',
  padding: theme.spacing(0.5),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

function EditProfileNpoStep(props) {
  const { userProfile, onSubmit, onBack, formData, onNext, onChange, saving } =
    props;

  const [recommendedNonProfits, setRecommendedNonProfits] = React.useState([]);
  const [preferredNonProfits, setPreferredNonProfits] = React.useState([]);
  const [companyFollowed, setCompanyFollowed] = React.useState([]);
  const [selectedNonProfits, setSelectedNonProfits] = React.useState([]);
  const [searchedNonProfits, setSearchedNonProfits] = React.useState([]);

  useEffect(() => {
    const fetchRecommendedNonProfits = async () => {
      try {
        let { data } = await authorizedServerFetch('nonprofits/recommended');
        data = data?.data;
        if (!isEmpty(data)) {
          setRecommendedNonProfits(data.recommended);
          setPreferredNonProfits(data.preferred);
        }
      } catch (err) {
        console.log('error', err);
      }
    };
    setCompanyFollowed(
      userProfile?.activeCommunity?.following?.nonprofits || [],
    );
    fetchRecommendedNonProfits();
  }, []);

  const handleAddNonProfit = (nonProfit) => {
    setSelectedNonProfits((prevSelectedNonProfits) => [
      ...prevSelectedNonProfits,
      nonProfit.id,
    ]);
    const updatedNpo = selectedNonProfits.map((nonProfit) => [
      ...nonProfit,
      nonProfit.id,
    ]);
    onChange(updatedNpo);
  };

  const handleDiscardNonProfit = (nonProfit) => {
    setSelectedNonProfits((prevSelectedNonProfits) => {
      return prevSelectedNonProfits.filter((npo) => npo.id !== nonProfit.id);
    });
    const updatedNpo = selectedNonProfits.filter(
      (npo) => npo.id !== nonProfit.id,
    );
    onChange(updatedNpo);
  };

  const handleSearchNonProfit = (searchedNpo) => {
    if (!searchedNpo || searchedNpo.length === 0) {
      setSearchedNonProfits([...recommendedNonProfits, ...preferredNonProfits]);
      return;
    }
    const searched = [...recommendedNonProfits, ...preferredNonProfits]?.filter(
      (npo) =>
        npo.name.toLowerCase().includes(searchedNpo.trim().toLowerCase()),
    );
    if (!isEmpty(searched)) {
      setSearchedNonProfits(searched);
    }
  };

  return (
    <div className="flex flex-col items-start justify-start gap-4">
      <div className="flex w-full">
        <Search
          placeholder="Search Nonprofit Org"
          onChange={(val) => handleSearchNonProfit(val)}
        />
      </div>
      {/* <div className="flex flex-col">
        <Typography variant="body2">NPO SUPPORTED BY COMPANY</Typography>
        <Stack
          gap={2}
          direction="row"
          flexWrap="wrap"
          className="overflow-y-auto max-h-[150px]">
          {userProfile?.company?.following?.nonprofits?.map((nonProfit) => (
            <CardContainer
              key={nonProfit.id}
            >
              <NonProfitItem nonProfit={nonProfit} companyFollowing={true} />
            </CardContainer>
          ))}
        </Stack>
      </div> */}
      <div className="flex w-full flex-col">
        <Typography variant="h5">NONPROFITS YOUR ORG SUPPORTS</Typography>
        <div
          // className='flex flex-col gap-4'
          className="mt-3 flex max-h-[100px] flex-row flex-wrap gap-4 overflow-y-auto">
          {[
            ...(!isEmpty(searchedNonProfits)
              ? searchedNonProfits
              : [...preferredNonProfits]),
          ]?.map((nonProfit) => (
            <CardContainer key={nonProfit.id}>
              <NonProfitItem
                user={userProfile}
                nonProfit={nonProfit}
                addNonProfit={handleAddNonProfit}
                discardNonProfit={handleDiscardNonProfit}
                companyFollowing={
                  !!companyFollowed.find((c) => c === nonProfit.id)
                }
              />
            </CardContainer>
          ))}
        </div>
      </div>

      <div className="flex w-full flex-col">
        <Typography variant="h5">RECOMMENDED NONPROFITS</Typography>
        <div
          // className='flex flex-col gap-4'
          className="mt-3 flex max-h-[300px] flex-row flex-wrap gap-4 overflow-y-auto">
          {[
            ...(!isEmpty(searchedNonProfits)
              ? searchedNonProfits
              : [...recommendedNonProfits]),
          ]?.map((nonProfit) => (
            <CardContainer key={nonProfit.id}>
              <NonProfitItem
                user={userProfile}
                nonProfit={nonProfit}
                addNonProfit={handleAddNonProfit}
                discardNonProfit={handleDiscardNonProfit}
                companyFollowing={
                  !!companyFollowed.find((c) => c === nonProfit.id)
                }
              />
            </CardContainer>
          ))}
        </div>
      </div>
      <div className="flex-rows flex w-full justify-end gap-4 pb-4">
        {/* <div className="flex-flow-col">
          <Button
            variant="outlined"
            color="primary"
            className="mt-2"
            onClick={onBack}>
            Back
          </Button>
        </div> */}
        {/* // TODO: check - no need of save button for npo form */}
        {/* {true ? (
          <div className="flex-flow-col">
            <StyledContainedButton
              variant="filled"
              color="primary"
              type="submit"
              className="mt-2"
              loading={saving}
              onClick={() => onSubmit({}, 'NPO Supported')}>
              Save
            </StyledContainedButton>
          </div>
        ) : (
          <div className="flex-flow-col">
            <StyledContainedButton
              disabled
              variant="outlined"
              color="primary"
              type="submit"
              className="mt-2"
              loading={saving}
              onClick={() => onSubmit({}, 'NPO Supported')}>
              Save
            </StyledContainedButton>
          </div>
        )} */}
      </div>
    </div>
  );
}

export default EditProfileNpoStep;
